import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import LoadingSpinner from 'components/LoadingSpinner';

import { selectIsLoading } from 'features/auth/authSelectors';

import useModuleAccess from 'hooks/useModuleAccess';

import { AppModules } from 'constants/enums';

interface PermissionWrapperProps {
  module: AppModules | null;
  children: ReactNode;
}

const PermissionWrapper = ({
  module,
  children
}: PermissionWrapperProps): JSX.Element => {
  const hasModuleAccess = useModuleAccess();
  const isLoading = useSelector(selectIsLoading);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const hasAccess = module === null || hasModuleAccess(module);

  if (!hasAccess) {
    return <div>Access Denied</div>;
  }

  return <>{children}</>;
};

export default PermissionWrapper;
